import React, {Component} from "react";
import {observer} from "mobx-react";
import {RouteComponentProps, withRouter} from "react-router-dom";
import {Web3Store} from "../stores/web3Store";
import {RootStore} from "../stores/rootStore";
import {Button, Checkbox, Tooltip} from "antd";
import {Swiper, SwiperSlide} from "swiper/react/swiper-react";
import "swiper/swiper.less";
import {Grid, Navigation} from "swiper";
import "swiper/modules/grid/grid.less";
import "../styles/licensePage.less";
import {IGetLicenseCollectionsResponse, ILicenseCollection, IMythServerResponse} from "../bean/ResponseBean";
import iconV from "../images/icons/icon-v.png";
import NoData from "../components/noData";
import {LeftCircleOutlined, RightCircleOutlined} from "@ant-design/icons";
import {INFTItem, LicenseButton} from "../components/licenseModal";
import MythImage from "../components/MythImage";
import {MythServerResultCode} from "../constant/CommonConstant";
import logger from "../logger";
import {IFeatchAccountNftsParams} from "../bean/OpenseaBean";
import {PageLoader} from "../components/pageLoader";
import {NoConnectedWallet} from "../components/noConnected/noConnectedWallet";
import {Retry} from "../components/retry/index";

interface IProps extends RouteComponentProps {
    web3Store: Web3Store;
    rootStore: RootStore;
}

interface IStates {
    licenseCollections: ILicenseCollection[],
    NFTList: INFTItem[],
    selectedNFTs: INFTItem[],
    selectedAll: boolean,
    checkedAgreement: boolean,
    autoFocus: boolean,
    loading: boolean,
    apiCallFailed:boolean
}

@observer
class LicensePage extends Component<IProps, IStates> {
    private firstRequest: boolean = true;
    private _collectionSelected: ILicenseCollection |undefined;

    private attention: string[] = ["Licensing NFT to the SuperBrands platform means that you allow other users to use the IP for free for online/offline display and allow artists to create new works for it.",
        "After licensing NFT, SuperBrands will become the broker of the IP and find opportunities for you to collaborate with brands.",
        "To ensure the security of your assets, the licensing process will not require any contractual authorization from you, and we will verify your licensed assets by reading your login address.",
        "For early backers, we will add an additional badge to your NFT IP homepage."
    ];

    constructor(props: IProps, state: IStates) {
        super(props);
        this.state = {
            licenseCollections: [],
            NFTList: [],
            selectedNFTs: [],
            selectedAll: false,
            checkedAgreement: false,
            autoFocus: false,
            loading: false,
            apiCallFailed:false
        }
    }

    back = () => {
        this.props.history.goBack();
    };

    checkNFTSelected = (item: INFTItem) => {
        const index = this.state.selectedNFTs.findIndex(value => {
            return value.nft.tokenId === item.nft.tokenId && value.nft.tokenAddress === item.nft.tokenAddress
        });
        return index;
    };

    selectItem = (nft: INFTItem, selected: boolean, indexInSelected: number) => {
        const {selectedNFTs} = this.state;

        if (nft.licensed) {
            return;
        }

        if (selected) {
            selectedNFTs.splice(indexInSelected, 1);
            this.setState({selectedAll: false})
        } else {
            selectedNFTs.push(nft);
        }
        this.setState({selectedNFTs: selectedNFTs});
    };

    selectAll = (e: any) => {
        const {selectedAll, NFTList} = this.state;
        if (selectedAll) {
            this.setState({selectedAll: false, selectedNFTs: []});
        } else {
            const selectedNFTs = NFTList.filter(value => {
                return !value.licensed;
            });
            this.setState({selectedAll: true, selectedNFTs: selectedNFTs})
        }
    };

    checkAgreement = (e: any) => {
        this.setState({
            checkedAgreement: e.target.checked
        })
    };

    componentDidMount(): void {
        this.getLicenseCollections();
    }

    getLicenseCollections = async () => {
        const {web3Store} = this.props;
        try {
            if (web3Store.mythServerApi) {
                const result: IMythServerResponse<IGetLicenseCollectionsResponse> = await web3Store.mythServerApi.getLicenseCollections();
                if (result.resultCode === MythServerResultCode.SUCCESS) {
                    const data = result.resultValue;
                    if (data) {
                        this.setState({
                            licenseCollections: data.licenseCollections
                        });
                    }
                }
            }
        } catch (e) {
            logger.error(e);
        }
    };

    onClickCollectionItem = (item: ILicenseCollection) => {
        this._collectionSelected = item;
        this.fetchNFTs(item);
    };

    fetchNFTs = async (licenseCollection: ILicenseCollection|undefined) => {
        if(!licenseCollection) {
            return;
        }

        const {web3Store} = this.props;
        if (web3Store.openseaApi && web3Store.account && licenseCollection) {
            this.setState({loading: true,apiCallFailed:false});

            const params: IFeatchAccountNftsParams = {
                ownerAddress: web3Store.account,//For test:0xb3e0A45EB952831a20eC1E1876bA706143A76623
                limit: 100,
                tokenAddresses: [licenseCollection.contractAddress],
                cursor: undefined
            };

            try {
                const result = await web3Store.openseaApi.fetchAccountNFTS(params);
                if (result && result.data) {
                    const nfts: INFTItem[] = result.data.map(value => {
                        return {nft: value, licensed: false, collectionId: licenseCollection.id};
                    });

                    this.getLicensedNFTTokenIds(licenseCollection, nfts);
                }
            } catch (e) {
                logger.error(e);
                this.setState({apiCallFailed:true});
            }
        }
    };

    getLicensedNFTTokenIds = async (iLicenseCollection: ILicenseCollection, nfts: INFTItem[]) => {
        const {web3Store} = this.props;

        if (web3Store.mythServerApi && web3Store.account && nfts && iLicenseCollection) {
            const tokenIds: string[] = [];
            nfts.forEach(value => {
                tokenIds.push(value.nft.tokenId);
            });

            try {
                const result = await web3Store.mythServerApi.getLicensedNFTTokenIds(web3Store.account, iLicenseCollection.id, tokenIds);
                if (result.resultCode === MythServerResultCode.SUCCESS) {
                    if (result.resultValue) {
                        nfts.forEach(nft => {
                            const licensed = result.resultValue.findIndex(value => {
                                return value === nft.nft.tokenId;
                            }) !== -1;
                            nft.licensed = licensed;
                        });

                        this.setState({
                            NFTList: nfts,
                            loading: false
                        });
                    }
                }
            } catch (e) {
                logger.error(e);
            } finally {
                this.setState({
                    loading: false
                });
            }
        }
    };

    private renderNFTItem(nftItem: INFTItem, index: number) {
        const indexInSelected = this.checkNFTSelected(nftItem);
        const selected = indexInSelected >= 0;
        const item = nftItem.nft;
        return <SwiperSlide key={index} className="nft-swiper-item">
            <div className="nft-item flex-row">
                <div
                    className={`image-box ${selected ? "selected" : ""}`}
                    onClick={() => this.selectItem(nftItem, selected, indexInSelected)}>
                    <MythImage src={item.image} alt=""/>
                    {nftItem.licensed&&<div className="shade">licensed</div>}
                </div>
                <div>
                    <p className="collection-name">{`${item.projectName} #${item.tokenId}`}</p>
                    <p className="limit">{item.projectName} <img src={iconV} alt=""/></p>
                </div>
            </div>
        </SwiperSlide>;
    }

    private renderMyNFTLiST(showNavigationBrand: string) {
        const {NFTList, selectedNFTs, loading,apiCallFailed} = this.state;
        const {web3Store} = this.props;

        return <div className="myth-panel">
                <Retry showRetry={apiCallFailed} onRetryClick={() => {this.fetchNFTs(this._collectionSelected)}}>
                    {loading ? <PageLoader marginTop={1}></PageLoader> :
                        NFTList.length > 0 ?
                            <>
                                <div className="nfts-container">
                                    <Swiper
                                        spaceBetween={20}
                                        slidesPerView={4}
                                        slidesPerGroup={4}
                                        grid={{
                                            fill: 'row',
                                            rows: 3
                                        }}
                                        navigation={{
                                            nextEl: ".swiper-next-nft",
                                            prevEl: ".swiper-prev-nft",
                                            disabledClass: "disabled"
                                        }}
                                        modules={[Grid, Navigation]}
                                        className="market-swiper"
                                    >
                                        {NFTList.map((item: INFTItem, index: number) =>
                                            this.renderNFTItem(item, index)
                                        )}
                                    </Swiper>
                                    <LeftCircleOutlined className="swiper-prev swiper-prev-nft"
                                                        style={{display: showNavigationBrand}}/>
                                    <RightCircleOutlined className="swiper-next swiper-next-nft"
                                                         style={{display: showNavigationBrand}}/>
                                </div>
                                {/* <div className="agreement"><Checkbox className="myth-checkbox"
                                                             onChange={this.checkAgreement}><span
                            className="check-label">Agree to SuperBrands IP licensing agreement</span></Checkbox></div> */}
                                <div className="text-center">
                                    <LicenseButton web3Store={web3Store} selectedNFTs={selectedNFTs} disabled={selectedNFTs.length !== 0}/>
                                </div>
                            </>
                            : <NoData/>}
                </Retry>
        </div>;
    }

    render() {
        const {web3Store} = this.props;
        const {licenseCollections, NFTList, selectedNFTs} = this.state;
        const showNavigationCollection = licenseCollections.length > 10 ? "block" : "none";
        const indeterminate = selectedNFTs.length > 0 && selectedNFTs.length < NFTList.length;

        return <div className="license-page-container">
            <Button className="btn-back" onClick={this.back}><i className="iconfont icon-chevron-left"></i>BACK</Button>
            <div className="list-title">License your NFT to SuperBrands platform</div>
            <div className="brand-container">
                <Swiper
                    spaceBetween={20}
                    slidesPerView={5}
                    slidesPerGroup={5}
                    grid={{
                        fill: 'row',
                        rows: 2
                    }}
                    navigation={{
                        nextEl: ".swiper-next-brand",
                        prevEl: ".swiper-prev-brand",
                        disabledClass: "disabled"
                    }}
                    modules={[Grid, Navigation]}
                    className="market-swiper"
                >
                    {licenseCollections.map((item: ILicenseCollection, index: number) => (
                        <SwiperSlide key={index} className="brand-swiper-item">
                            <div className="brand-item" onClick={event => {
                                this.onClickCollectionItem(item)
                            }}>
                                <img src={item.bgImage} className="item-img" alt=""/>
                                <Tooltip title={item.name} color="rgba(255,255,255,0.8)"
                                         overlayClassName="tool-content">
                                    <div className="item-name">{item.name}</div>
                                </Tooltip>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
                <LeftCircleOutlined className="swiper-prev swiper-prev-brand" style={{display: showNavigationCollection}}/>
                <RightCircleOutlined className="swiper-next swiper-next-brand" style={{display: showNavigationCollection}}/>
            </div>
            <div className="select-all-container">
                <Checkbox className="myth-checkbox" onChange={this.selectAll} indeterminate={indeterminate}><span
                    className="check-label">Select all</span></Checkbox>
                <span>( {selectedNFTs.length} NFTs selected )</span>
            </div>
            {web3Store.account ?
                this.renderMyNFTLiST(showNavigationCollection):
                <NoConnectedWallet web3Store={web3Store}/>
            }
            <div className="list-title">Attention</div>
            <ol className="attention-container">
                {this.attention.map((item, i) => (
                    <li key={i}>{item}</li>))}
            </ol>
        </div>
    }
}

export default withRouter(LicensePage);
